export default {
  socialNetworks: '社交网络',
  sentEmails: '发送电子邮件',
  peoplePerDay: '每天的人',
  peoplePerMonth: '每月人员',
  statsPerApp: '应用程序统计信息',
  search: '搜索',
  name: '名字',
  people: '人',
  person: '人',
  sentMessages: '发送消息',
  messagesParts: '消息部件',
  applicationsPerPage: '每页应用程序',
  cellphoneRecords: '手机记录',
  totalRecords: '记录总数',
  noName: '无名',
  noAppsToShow: '没有要显示的应用',
  manualPayment: '人工付款',
  manualCollection: '手动收集',
  noDataYet: '目前没有数据'
}
